import {
  createAsyncThunk,
  ActionReducerMapBuilder,
  createAction,
} from '@reduxjs/toolkit';

import type { ThunkExtra } from '@app/store';

import { AuthRouterService } from '../../../services';
import { AuthState, clearState } from '../../auth.state';
import { AuthCandidateIdService } from '../../../services/candidate/auth-candidate-id.service';

/** @knipignore */
export const clearAuthState = createAction<void>('auth/clearState');

export const redirectToLogin = createAsyncThunk<void, void, ThunkExtra>(
  'auth/redirectToLogin',
  (_, { dispatch, extra: { inject } }) => {
    dispatch(clearAuthState());
    inject(AuthRouterService).redirectToLogin();
  },
);

export const redirectToCandidateLogin = createAsyncThunk<
  void,
  string,
  ThunkExtra
>('auth/redirectToCandidateLogin', (id, { dispatch, extra: { inject } }) => {
  dispatch(clearAuthState());
  inject(AuthCandidateIdService).save(id);
  inject(AuthRouterService).redirectToCandidateLogin();
});

export const redirectToPasswordChange = createAsyncThunk<
  void,
  string | undefined,
  ThunkExtra
>(
  'auth/redirectToPasswordChange',
  (authInstanceId, { dispatch, extra: { inject } }) => {
    dispatch(clearAuthState());
    inject(AuthRouterService).redirectToPasswordChange(authInstanceId);
  },
);

export const redirectToSendInviteForPhone = createAsyncThunk<
  void,
  void,
  ThunkExtra
>('auth/redirectToSendInviteForPhone', (_, { dispatch, extra: { inject } }) => {
  dispatch(clearAuthState());
  inject(AuthRouterService).redirectToSendInviteForPhone();
});

export const redirectToQr = createAsyncThunk<void, void, ThunkExtra>(
  'auth/redirectToPhoneChange',
  (_, { dispatch, extra: { inject } }) => {
    dispatch(clearAuthState());
    inject(AuthRouterService).redirectToQr();
  },
);

export const routerReducers = (builder: ActionReducerMapBuilder<AuthState>) => {
  builder.addCase(clearAuthState, (state) => {
    clearState(state);
  });
};
